import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { forgetPasswordAPI, loginAPI, signupAPI } from "../api/AuthApi";
import jwt_decode from "jwt-decode";
import { saveToken } from "../token/token";
import { openEdgeSession } from "../util/openEdgeSession";

const initialState = {
  login: null,
  loading: null,
  error: {},
};

export const singup = createAsyncThunk(
  "auth/singup",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await signupAPI(payload);
      window.location = "/";
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await loginAPI(payload);
      if (response.data.success) {
        const { accessToken, refreshToken } = response?.data?.response || {};
         await openEdgeSession(
          process.env.REACT_APP_CLOUDFRONT_DOMAIN,
          accessToken
        );

        if (
          jwt_decode(response?.data?.response?.accessToken)?.role === "ADMIN"
        ) {
          window.location = "/admin/orders-management";
        } else {
          window.location = "/admin/home";
        }

        return response;
      } else {
        throw new Error(response.data.message);
      }
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const forgetPassword = createAsyncThunk(
  "auth/forgetPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await forgetPasswordAPI(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: (builder) => {
    //login user
    builder.addCase(login.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.login = action.payload.data.response.accessToken;
      saveToken(action.payload.data.response.accessToken);
      state.loading = false;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //signup user
    builder.addCase(singup.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(singup.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(singup.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default authSlice.reducer;
